import React, { useState } from 'react';

import './styles.css';

import ContestService from '../../services/Contest'

import FileIcon from '../../assets/file-icon.svg';

import { CircularProgress } from '@material-ui/core'

export default function Submit() {

    const [title, setTitle] = useState('')
    const [authorName, setAuthorName] = useState('')
    const [authorEmail, setAuthorEmail] = useState('')
    const [category, setCategory] = useState('')
    const [description, setDescription] = useState('')
    const [document, setDocument] = useState(null)

    const [approvedTerms, setApprovedTerms] = useState('')

    const [loading, setLoading] = useState(false)

    const verify = () => {
        return (
            title.length && authorName.length &&
            authorEmail.length && category.length &&
            description.length && document && approvedTerms
        )
    }

    const setEmptyState = () => {
        setTitle('')
        setAuthorName('')
        setAuthorEmail('')
        setCategory('')
        setDescription('')
        setDocument(null)
    }

    const handleForm = (e) => {
        e.preventDefault()

        setApprovedTerms(false)
        setLoading(true)
        ContestService.create({
            title,
            authorName,
            authorEmail,
            category,
            description,
            document
        }).then(() => {
            alert('Seu concurso está em análise!')
            setApprovedTerms(true)
            setLoading(false)
            setEmptyState()
        }).catch(err => {
            alert('Erro ao processar requisição')
            console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
        })

    }

    return (
        <>

        <div id="submit-container">
            <div id="submission-text-box">
                <div id="submission-text-container">
                    <h1>SUBMISSÃO</h1>
                    <p>
                        Para participar do I Concurso Ambiental, submeta seu(s) trabalho(s) na(s) categoria(s) selecionada(s) no formulário de inscrição.
                        <br />
                        <br />
                        O(s) trabalho(s) pode(m) ser submetido(s) durante o período de 29 de maio ao dia 02 de junho do corrente ano.
                        <br />
                        <br />
                        Todas as regras e condições para a participação no I Concurso Ambiental estão descritas no Regulamento Geral.
                    </p>
                </div>
            </div>
            <div id="form-container">
                <form onSubmit={handleForm}>
                    <div className="organization">
                        <div className="input-text">
                            <label>Título:</label>
                            <input
                                type="text"
                                id="title"
                                value={title}
                                onChange={e => setTitle(e.target.value)}
                            />
                        </div>
                        <div className="input-text">
                            <label>Nome do participante:</label>
                            <input
                                type="text"
                                id="name"
                                value={authorName}
                                onChange={e => setAuthorName(e.target.value)}
                            />
                        </div>

                        <div className="input-text">
                            <label>E-mail:</label>
                            <input
                                type='text'
                                id="e-mail"
                                value={authorEmail}
                                onChange={e => setAuthorEmail(e.target.value)}
                            />
                        </div>

                        <div className="input-text-area">
                            <label>Descrição:</label>
                            <textarea
                                name="text-area"
                                id="text-area"
                                value={description}
                                onChange={e => setDescription(e.target.value)}
                            />
                        </div>
                    </div>

                    <div id="organization-two" className="organization organization-two">

                        <div id="select-box">
                            <select name="category" value={category} onChange={e => setCategory(e.target.value)} id="category" required>
                                <option value="">Selecione uma opção</option>
                                <option value='Ações ambientais e/ou sociais (vídeos)'>Ações ambientais e/ou sociais (vídeos)</option>
                                <option value='Fotografia'>Fotografia</option>
                                <option value='Música / Paródia'>Música / Paródia</option>
                                <option value='Poemas / Cordel'>Poemas / Cordel</option>
                                <option value='Charges'>Charges</option>
                                <option value='Tirinhas'>Tirinhas</option>
                                <option value='Desenho'>Desenho</option>
                            </select>
                        </div>

                        <div id="file-box">
                            <label htmlFor="file">
                                Arquivo:
                            <div id="new-file">
                                    <img src={FileIcon} alt="Icone de arquivo" />
                                    {document ? (
                                        document.name
                                    ) : (
                                            ''
                                        )}
                                </div>
                            </label>
                            <input type="file" onChange={e => setDocument(e.target.files[0])} name="file" id="file" />
                        </div>

                        <div id="terms-of-use-box">
                            <div>
                                <input type="checkbox" onChange={e => setApprovedTerms(e.target.checked)} name="terms" id="terms" />
                                <span>Concordo com o &nbsp;</span>
                                <a href={'https://drive.google.com/file/d/1_Un-lGbZClS4sndlZ0viyjCMVcWZlgG5/view'} rel="noopener noreferrer" target='_blank'>Regulamento</a>
                            </div>
                        </div>
                        {verify() ? (
                            <button type='submit' >Enviar</button>
                        ) : (
                                <button className="btDisable" type='submit' disabled >Enviar</button>
                            )}

                    </div>
                </form>
            </div>
        </div>

            {(loading) ? (
                <div id="loading-container-submit">
                    <CircularProgress />
                </div>
            ) : ''}
        </>
    )
}
